import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ScreenUtilsService } from "../utils";
import { MessageBoxComponent } from "./message-box.component";

export type MessageBoxButtons = 'YesNo' | 'Ok';

export type MessageBoxAnswer<T extends MessageBoxButtons = MessageBoxButtons> =
    T extends 'YesNo' ? 'Yes' | 'No' :
    T extends 'Ok' ? 'Ok' :
    never;


export interface IShowMessageBoxParams<T extends MessageBoxButtons = MessageBoxButtons, TTranslationKey extends string = string> {
    buttons: T,
    type: 'info' | 'warning' | 'prompt',
    title?: TTranslationKey,
    subtitle?: TTranslationKey,
    text: TTranslationKey,
    no?: TTranslationKey,
    yes?: TTranslationKey,

    replace?: Record<string, string>
}
@Injectable({ providedIn: 'root' })
export class MessageBoxService<TTranslationKey extends string = string> {

    dialogRef: MatDialogRef<MessageBoxComponent, MessageBoxAnswer>
    readonly screenSizeSubject = this._screenUtilsService.screenSizeSubject;
    get screenSize() {
        return this.screenSizeSubject.value;
    }
    constructor(
        private readonly _dialog: MatDialog,
        private readonly _screenUtilsService: ScreenUtilsService
    ) {

    }

    show<T extends MessageBoxButtons>(params: IShowMessageBoxParams<T, TTranslationKey>): Observable<MessageBoxAnswer> {

        const dialogRef = this._dialog.open<MessageBoxComponent, IShowMessageBoxParams<T, TTranslationKey>, MessageBoxAnswer<T>>(
            MessageBoxComponent,
            {
                data: params,
                panelClass: !['sm', 'xs'].includes(this.screenSize) ? 'col-width-large' : undefined,
                minWidth: ['sm', 'xs'].includes(this.screenSize) ? '100%' : undefined,
                height: ['sm', 'xs'].includes(this.screenSize) ? '100%' : 'auto'
            }
        )

        this.dialogRef = dialogRef;

        return dialogRef.afterClosed()
    }

    close(result?: MessageBoxAnswer) {
        this.dialogRef.close(result);
    }
}